// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","chevron":"Pagination_chevron__5BoJV","active":"Pagination_active__q3h4d"};